<template>
  <section ref="widgetSection" class="widget-section">
    <div class="widget" id="widget"></div>
  </section>
</template>

<script>
import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import logo from '@/assets/img/logo.svg';
import { demoRooms } from '@/enums/demoRooms';

const WIDGET_API_URL = 'https://backend.estate.hart-digital.com';

export default {
  name: 'Widget',
  data() {
    return {
      demoRooms,
    };
  },
  mounted() {
    this.$refs.widgetSection.style.setProperty('--vh', `${window.innerHeight / 100}px`);
    this.$refs.widgetSection.style.setProperty('--vw', `${window.innerHeight.offsetWidth / 100}px`);
    this.createWidget(window.location.origin);
  },
  methods: {
    async createWidget(logoUrl) {
      const { searchParams } = new URL(document.location);

      const type = searchParams.get('type');
      const style = searchParams.get('style');
      const lang = searchParams.get('lang') || 'en';

      const planId = searchParams.get('id');
      if (!planId) {
        return null;
      }

      const widgetApiHandler = new ApiStore(WIDGET_API_URL);

      const planData = await widgetApiHandler.loadWidgetData(planId);

      const preset = this.demoRooms[style]?.[type];

      const options = {
        ...planData.parsed,
        API_URL: WIDGET_API_URL,
        panoramaFov: 75,
        rotationMode: rotationModes.DEFAULT,
        logo: document.location.pathname.includes('widget-clear') ? '' : logo,
        tabs: ['panorama', 'rotation'],
        locale: lang,
        logoUrl,
        demoRoomType: type,
        demoRoomStyle: style,
        primaryCameraPointId: preset?.id,
        colors: { main: '#FFA900', mainText: '#413E3E' },
      };

      const widget = new Widget('#widget', options);

      if (preset) {
        widget.panoramaStore.camera.controls.rotate(-preset.cameraRotation, 0, false);
      }

      return widget;
    },
  },
};
</script>

<style scoped>
.widget-section {
  --vh: 1vh;
  --vw: 1vw;
  width: 100vw;
  height: calc(100 * var(--vh));
}
.widget {
  width: 100%;
  height: 100%;
}
.widget-application {
  width: 100% !important;
  height: 100% !important;
}
</style>
